



























































































import { Component, Vue } from 'vue-property-decorator';
import { emailApis, EmailArchiveItem, EmailBodyResult, QueryEmailsParams } from '@/api/email.api';
import Pagination from '@/components/Pagination.vue';
import moment from 'moment';
import { handleClipboard } from '@/common/clipboard';

const DEFAULT_FILTERS = {
  from_email: '',
  to_email: '',
  send_at_range: null as [string, string] | null,
  keyword: '',
  message_id: ''
};

@Component({ components: { Pagination } })
export default class EmailSearchPage extends Vue {
  filters = {
    ...DEFAULT_FILTERS
  };

  mounted() {
    this.filters = {
      ...DEFAULT_FILTERS,
      send_at_range: [
        moment()
          .subtract(30, 'days')
          .startOf('day')
          .format('YYYY-MM-DDTHH:mm:ss'),
        moment()
          .add(1, 'days')
          .startOf('day')
          .format('YYYY-MM-DDTHH:mm:ss')
      ] as [string, string]
    };
  }
  listResult: { items: EmailArchiveItem[]; total: number } = { items: [], total: 0 };
  pagination = { page: 1, limit: 20 };
  loading = false;
  bodyDialog = {
    visible: false,
    loading: false,
    title: '',
    content: '',
    downloadUrl: ''
  };

  handleCopy(text: string, event: MouseEvent) {
    handleClipboard(text, event);
  }

  buildParams(): QueryEmailsParams {
    const params: QueryEmailsParams = {
      skip: (this.pagination.page - 1) * this.pagination.limit,
      limit: this.pagination.limit
    };
    if (this.filters.from_email) params.from_email = this.filters.from_email;
    if (this.filters.to_email) params.to_email = this.filters.to_email;
    if (this.filters.send_at_range) {
      params.send_at_start = this.filters.send_at_range[0];
      params.send_at_end = this.filters.send_at_range[1];
    }
    if (this.filters.keyword) params.keyword = this.filters.keyword;
    if (this.filters.message_id) params.message_id = this.filters.message_id;
    return params;
  }

  async fetchEmails() {
    try {
      this.loading = true;
      this.listResult = await emailApis.queryEmails(this.buildParams());
    } catch (error) {
      this.$message.error(`查询邮件失败: ${error.message || error}`);
    } finally {
      this.loading = false;
    }
  }

  handleSearch() {
    this.pagination.page = 1;
    this.fetchEmails();
  }

  handleReset() {
    this.filters = { ...DEFAULT_FILTERS };
    this.pagination.page = 1;
  }

  handlePageChange() {
    this.fetchEmails();
  }

  formatTime(v: string) {
    return moment(v).format('YYYY-MM-DD HH:mm:ss');
  }

  async handleViewBody(row: EmailArchiveItem) {
    this.bodyDialog.visible = true;
    this.bodyDialog.loading = true;
    this.bodyDialog.title = row.subject || '邮件正文';
    this.bodyDialog.content = '';
    this.bodyDialog.downloadUrl = emailApis.getEmlDownloadUrl(row.message_id);
    try {
      const data: EmailBodyResult = await emailApis.getEmailBody(row.message_id);
      this.bodyDialog.content = data.body_text;
    } catch (error) {
      this.$message.error(`获取邮件正文失败: ${error.message || error}`);
      this.bodyDialog.visible = false;
    } finally {
      this.bodyDialog.loading = false;
    }
  }
}
